module.exports = __webpack_public_path__ + "static/media/libreria-paquita-1.b820731f.png";